import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderUiDialogResult} from './VanillaReaderUiModel';
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiDialogImageViewerController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiDialogImageViewerController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogImageViewer` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogImageViewer
 */
export class VanillaReaderUiDialogImageViewerController {
    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogImageViewer.onDialogClosed(vanillaReaderUiContext._onDialogImageViewerDialogClosed.bind(vanillaReaderUiContext));
    }

    _onDialogImageViewerDialogClosed(dialogResult: IVanillaReaderUiDialogResult<string>): void {
        this.vanillaReaderAPI.revokeMediaObjectUrl(dialogResult.data);
    }

}
